import { SchemaSection, WidgetConfiguration } from './types';
import { buildSettingsDefaults } from './buildSetting';

export function parseTabSchemaDefaults(tabSections: SchemaSection[]): WidgetConfiguration {
    let configuration: WidgetConfiguration = {};
    tabSections.forEach(
        (section: SchemaSection): void => {
            const settingsDefaults = buildSettingsDefaults(section.settings);
            configuration = {
                ...configuration,
                ...settingsDefaults,
            };
        }
    );

    return configuration;
}
